import { Body, Stack, useWindowProperties } from '@qred/components-library';
import { currencyFormatter } from '@qred/fe-cp-formatting-helpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { LabelValueGrid } from '~/components/shared/Layout/LabelValueGrid';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';

export const CardOfferView = () => {
  const {
    intl: { market },
    cardOffer: {
      overview: { companyName, offeredCreditLimit },
    },
  } = useSelector((state: RootState) => state);

  const translate = useTranslate();
  const { isMobile } = useWindowProperties();
  const formatter = currencyFormatter(market);

  const cardDetailsLabelAndValue1 = [
    {
      label: translate('CreditCardDetailsCard.CompanyName') as string,
      value: companyName,
    },
    {
      label: translate('CreditCardDetailsCard.ApprovedCredit') as string,
      value: formatter.format(offeredCreditLimit),
    },
  ];

  const cardDetailsLabelAndValue2 = [
    {
      label: translate('CreditCardDetailsCard.YearlyMonthlyFee') as string,
      value: formatter.format(0),
    },
    {
      label: translate(
        'CreditCardDetailsCard.InterestFreePeriodLabel'
      ) as string,
      value: translate(
        'CreditCardDetailsCard.InterestFreePeriodValue'
      ) as string,
    },
  ];

  return (
    <>
      <Stack spacing={'xxl'}>
        <LabelValueGrid
          items={cardDetailsLabelAndValue1}
          isMobile={isMobile}
          gridTemplateColumns="auto"
        />
        <LabelValueGrid
          items={cardDetailsLabelAndValue2}
          isMobile={isMobile}
          gridTemplateColumns="auto"
        />
      </Stack>
      <Body size="lg" mt={50} align="center">
        {translate('CreditCardDetailsCard.CashbackInfo')}
      </Body>
    </>
  );
};
